export function formatPhoneNumber (phone: string): string {
  const digits = phone.replace(/\D/g, '')

  if (digits.length !== 11) return phone

  const countryCode = '+7'
  let rest = digits

  if (rest.startsWith('8')) {
    rest = '7' + rest.slice(1)
  }

  if (!rest.startsWith('7')) return phone

  const operatorCode = rest.slice(1, 4)
  const part1 = rest.slice(4, 7)
  const part2 = rest.slice(7, 9)
  const part3 = rest.slice(9, 11)

  return `${countryCode} ${operatorCode} ${part1}-${part2}-${part3}`
}
